// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3lyVx","imageUploader":"EGiftCard_imageUploader__1OvnC"};